import {
	buildLocalizedSeoLinks,
	getLocalizedSeoUrls,
	ogImageUrl,
	ogSlugForPath,
} from "@/lib/seo";

export function buildPageHead({
	matches,
	internalPath,
	title,
	description,
	ogImage,
	ogType = "website",
}: {
	matches: unknown;
	internalPath: string;
	title: string;
	description: string;
	ogImage?: string;
	ogType?: "website" | "article";
}) {
	const seoUrls = getLocalizedSeoUrls({ matches, internalPath });
	const image = ogImageUrl(ogImage ?? ogSlugForPath(internalPath));

	return {
		meta: [
			{ title },
			{ name: "description", content: description },
			{ property: "og:title", content: title },
			{ property: "og:description", content: description },
			{ property: "og:image", content: image },
			{ property: "og:url", content: seoUrls.canonicalUrl },
			{ property: "og:type", content: ogType },
			{ property: "og:site_name", content: "AgentFramer" },
			{ name: "twitter:card", content: "summary_large_image" },
			{ name: "twitter:image", content: image },
		],
		links: buildLocalizedSeoLinks({ matches, internalPath }),
	};
}
